import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { format, subYears } from 'date-fns';
import config from '../config';

// Note: not setting baseURL here for we may use many diff urls
// only good to have one createApi. Throws merge error if you attempt two have multiple createApis
// Therefore putting baseURL inside each ineject endpoint file. See migration.js or employee.js
// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  baseQuery: fetchBaseQuery({
    reducerPath: 'api',
    prepareHeaders: (headers, { getState, _endpoint }) => {
      const { token } = getState().user ?? {};
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 60,
  endpoints: () => ({}),
});

export const catchApiError = (err) => {
  if (err.response && err.response.status === 401) {
    window.top.postMessage('expired-jwt', '*');
  }
};

export const userParam = (user) => {
  const { usingLeadershipRole, site } = user ?? {};
  const path = usingLeadershipRole ? 'users' : `${site}`;
  return path;
};

export const formatDate = (date) => {
  const formattedDate = (d) => format(d, 'yyyy-MM-dd');
  return formattedDate(date);
};

export const parseValue = (value) => {
  if (value % 1 !== 0) {
    return `${parseFloat(value).toFixed(2)}`;
  }
  return `${parseInt(value, 10)}`;
};

export const startDate = () => format(subYears(new Date(), 1), 'yyyy-MM-dd');

export const getTwpUserPath = () => {
  return `${config.twpApiURL}/users`;
};

export const getTwpPath = (user) => {
  const { site } = user ?? {};
  return `${config.twpApiURL}${site ? `/${site}` : ''}`;
};

export const getMdsPath = () => {
  return `${config.mdsApiUrl}/api`;
};

export const getTsPath = (user) => {
  const { site, product, hasEmployeeRole } = user ?? {};
  const userText =
    product.toLowerCase() === 'twpemp' || hasEmployeeRole ? '/user' : '';
  const path = `${config.tsApiUrl}${userText}/${site}`;
  return path;
};
